import { useIntl } from 'react-intl';
import { SectionHeading } from '@ets/design-system';
import getConfig from 'dodoc.config';

import { Setting } from 'Settings/components';
import IntlErrorBoundary from '_common/components/IntlErrorBoundary/IntlErrorBoundary';

import NotificationSettings from './NotificationSettings/NotificationSettings';

import styles from './General.module.scss';

const General = () => {
  const intl = useIntl();

  return (
    <>
      <div className={styles.sectionHeading}>
        <SectionHeading
          size="l"
          title={intl.formatMessage({ id: 'settings.tabs.general' })}
          testId="general-settings"
        />
      </div>
      <IntlErrorBoundary size="xl" style={{ margin: '10rem 0 9rem 0' }}>
        <Setting
          style={{ alignItems: 'flex-start' }}
          label={intl.formatMessage({ id: 'settings.general.title' })}
          testId="tenant-title"
        >
          {getConfig().tenant || window.location.hostname}
        </Setting>
      </IntlErrorBoundary>
      <div className={styles.notificationSettingsContainter}>
        <SectionHeading
          size="l"
          title={intl.formatMessage({ id: 'NOTIFICATIONS' })}
          sticky
          testId="notification-settings"
        />
      </div>
      <IntlErrorBoundary size="xl" style={{ margin: '10rem 0 9rem 0' }}>
        <NotificationSettings />
      </IntlErrorBoundary>
    </>
  );
};

export default General;
